import React from "react";
import NoDataFound from "../NoDataFound";

export const Table = ({ columns, data ,tableClass}) => {
  const validData = Array.isArray(data) ? data : [] ;
 
  return (
    <div className={`${tableClass} overflow-x-auto `}>
      <table className="min-w-full bg-white">
        <thead className="sticky top-0 bg-white" >  
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className= " py-3 px-4 text-xs sm:text-sm font-bold text-custom-black whitespace-nowrap text-center "
                // className="py-3 px-4 text-left text-sm font-bold text-custom-black"
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {validData.length > 0 ? (
            validData.map((row, rowIndex) => (
              <tr key={rowIndex} className={rowIndex % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                {columns.map((column, colIndex) => (
                  <td key={colIndex} className="min-w-12 max-w-16 py-3 px-4 text-xs sm:text-sm whitespace-normal break-words text-center ">
                    {column.customBtn ? column.customBtn(row) :column.customTxt ? column.customTxt(row)  :row[column.accessor] || "N/A"}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center py-4">
               <NoDataFound/>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
